<label [tcTooltip]="tooltipText">{{ inputHeaderLabel }}</label>
<div class="editor-container">
    <quill-editor
        [placeholder]="_placeholder"
        [(ngModel)]="editorContent"
        (ngModelChange)="_emitChanges(true)"
        [styles]="{ minHeight: inputMinHeight, height: inputFixedHeight }"
        [sanitize]="true"
        [required]="required"
        [modules]="_modules"
    >
    </quill-editor>
    <textarea
        class="raw-input"
        [class.visible]="showCodeView"
        [(ngModel)]="rawContent"
        (ngModelChange)="_emitChanges(false)"
    >
    </textarea>
    <terra-button
        [class.visible]="showCodeView && _isValidMarkup"
        class="close-button"
        inputIcon="icon-close"
        (outputClicked)="_closeCodeView()"
    >
    </terra-button>
    <terra-button
        [class.visible]="showCodeView && !_isValidMarkup"
        class="error-button"
        inputIcon="icon-warning"
        [inputTooltipText]="_invalidMarkupHint"
        inputTooltipPlacement="left"
    >
    </terra-button>
    <terra-overlay
        #viewConfirmationOverlay
        [inputOverlayTitle]="'terraCodeEditor.changeViewOverlay.title' | translate: _locale.language"
        [inputPrimaryButtonInterface]="_viewConfirmation.primaryButton"
        [inputSecondaryButtonInterface]="_viewConfirmation.secondaryButton"
        class="preview-overlay"
    >
        <p>{{ 'terraCodeEditor.changeViewOverlay.text' | translate: _locale.language }}</p>
    </terra-overlay>
</div>
